var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-expansion-panels",
        {
          model: {
            value: _vm.expandedArray,
            callback: function($$v) {
              _vm.expandedArray = $$v
            },
            expression: "expandedArray"
          }
        },
        [
          _c(
            "v-expansion-panel",
            { staticClass: "grey lighten-3" },
            [
              _c("v-expansion-panel-header", [
                _c("span", [
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("delegation.form.additionalTransportCost")
                      ) + " "
                    )
                  ]),
                  _c("span", [
                    _c("b", { staticClass: "green--text" }, [
                      _vm._v(_vm._s(_vm.count))
                    ])
                  ])
                ])
              ]),
              _c(
                "v-expansion-panel-content",
                { staticClass: "grey lighten-5" },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c("simple-other-transport-list", {
                        staticClass: "ma-2",
                        attrs: {
                          clearable: _vm.clearable & !_vm.readonly,
                          "model-other": _vm.contextOther
                        },
                        on: {
                          removeOtherItem: _vm.removeOther,
                          "update:modelOther": function($event) {
                            _vm.contextOther = $event
                          },
                          "update:model-other": function($event) {
                            _vm.contextOther = $event
                          }
                        }
                      }),
                      _vm.addable && !_vm.readonly
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "accent" },
                              on: {
                                click: function($event) {
                                  return _vm.addOther()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("global.add")))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }